var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white","height":"90%","width":"100%","overflow-x":"auto"}},[_c('h1',[_vm._v("다축 그래프")]),_c('div',{ref:"multiAxisChart",staticStyle:{"width":"70%","height":"800px"}}),_c('h1',[_vm._v("온도-전력량 및 습도-전력량 산포도 비교")]),_c('div',{ref:"scatterChart",staticStyle:{"width":"70%","height":"800px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }